// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iSvB","question":"styles_question__3KGa_","description":"styles_description__3bN3l"};